module.exports = __webpack_public_path__ + "static/media/neurospyt.84aaa5d0.jpg";